import { atom, getDefaultStore, useAtomValue } from 'jotai';

export type MaintenanceState = {
  active: boolean;
  maintenanceEndDate?: string;
  messageEn?: string;
  messagePl?: string;
};

const DEFAULT_STATE: MaintenanceState = { active: false };

export const maintenanceAtom = atom<MaintenanceState>(DEFAULT_STATE);

export const useMaintenanceState = (): MaintenanceState => useAtomValue(maintenanceAtom);

export const setMaintenanceActive = (payload: Omit<MaintenanceState, 'active'>): void => {
  getDefaultStore().set(maintenanceAtom, { active: true, ...payload });
};

export const clearMaintenance = (): void => {
  getDefaultStore().set(maintenanceAtom, DEFAULT_STATE);
};
